import axios from "axios";

export default {
    namespaced: true,

    state: {
        geojson: null,
        features: [],
    },

    getters: {
        mapData(state) {
            return state.mapData;
        },
        geojson(state) {
            return state.geojson;
        },
    },

    mutations: {
        SET_MAP_DATA(state, mapData) {
            state.mapData = mapData;
        },
        SET_MAP_FEATURES(state, features) {
            state.geojson = {
                type: "FeatureCollection",
                name: "LV_pagasti_WGS84",
                crs: {
                    type: "name",
                    properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
                },
                features: features,
            };
            // console.log("geo", this.state.geojson);
        },
    },

    actions: {
        async getMapData({ commit }) {
            await axios.get("/api/get-map-data").then((response) => {
                // console.log("response", response);
                const features = [];
                for (let i in response.data) {
                    features.push(response.data[i].geometry);
                }
                // console.log("features", features);
                commit("SET_MAP_FEATURES", features);
                commit("SET_MAP_DATA", response.data);
            });
        },
    },
};
